import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import DefaultTable, { Line } from "../../ui-library/CustomTable/DefaultTable";
import moment from "moment";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { DateFormat } from "../../../modules/constants";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 60px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const DailyTargetsHistory = (props) => {
  const { onClose, getData, searchedParams, totalitems, theme, history } =
    props;

  const { t } = useTranslation();

  const defaultProps = {
    headers: [
      { label: t("appText.date"), key: "date" },
      { label: t("appText.dietDiary.calories"), key: "calories" },
      { label: t("appText.dietDiary.protein"), key: "protein" },
      { label: t("appText.dietDiary.carbohydrates"), key: "carbohydrates" },
    ],
    hasSearch: 0,
    haspagesizefilter: 0,
    haspagination: 1,
    smallTable: true,
    searchedParams,
    getData,
  };

  return (
    <Container data-testid="daily-targets-history">
      <DefaultTable
        {...defaultProps}
        maincolor={theme?.gray}
        totalitems={totalitems}
      >
        {history?.map((history, index) => (
          <Line key={`${history.Key}_${index}`}>
            <span>
              {moment
                .utc(history.updatedAt)
                .utcOffset(history.timeZoneOffset)
                .format(DateFormat.BASE_FORMAT)}
            </span>
            <span>{`${history.calories} kcal`}</span>
            <span>{`≥ ${history.proteinPercentage}%`}</span>
            <span>{`< ${history.carbohydratesPercentage}%`}</span>
          </Line>
        ))}
      </DefaultTable>
      {onClose && (
        <ActionButtonsContainer>
          <PrimaryButton data-testid="close-button" onClick={onClose}>
            {t("appText.close")}
          </PrimaryButton>
        </ActionButtonsContainer>
      )}
    </Container>
  );
};

DailyTargetsHistory.defaultProps = {
  onClose: null,
};

DailyTargetsHistory.propTypes = {
  onClose: PropTypes.func,
  searchedParams: PropTypes.object.isRequired,
  getData: PropTypes.func.isRequired,
  totalitems: PropTypes.number.isRequired,
  history: PropTypes.array.isRequired,
};

export default withTheme(DailyTargetsHistory);
